// extracted by mini-css-extract-plugin
export var title = "ExclusiveTours-module--title--3mDKU";
export var tour = "ExclusiveTours-module--tour--2Jd4E";
export var tourTitle = "ExclusiveTours-module--tourTitle--4zo5X";
export var overlay = "ExclusiveTours-module--overlay--2r53q";